import { Control, FieldValues, UseFormRegister } from 'react-hook-form';

import { EanUtils } from '../../common/eanUtils';
import { ReactComponent as InformationIcon } from '../../assets/information.svg';
import Input from './Input';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface InputEanProps {
  register: UseFormRegister<FieldValues>;
  defaultValue?: string;
  error?: string;
  mask?: string;
  control?: Control<FieldValues>;
  dataTestId?: string;
  onClickInfo?: () => void;
}

interface MaskedInputState {
  value: string;
  selection: {
    start: number;
    end: number;
  };
  enteredString?: string;
}

interface BeforeMaskedValueChangeState {
  nextState: MaskedInputState;
}

export const PREFIX = '5414489';
export default function InputEAN({
  register,
  defaultValue,
  error,
  control,
  dataTestId,
  onClickInfo,
}: InputEanProps) {
  const { t } = useTranslation();
  const handleBeforeMaskedValueChange = (newState: BeforeMaskedValueChangeState) => {
    const { value, selection } = newState.nextState;
    const enteredString = newState.nextState.enteredString;
    if (enteredString?.includes(PREFIX)) {
      const newValue = enteredString.replace(PREFIX, '');
      return {
        value: newValue,
        selection: { start: 0, end: 0 },
      };
    }
    return {
      value,
      selection,
    };
  };

  return (
    <Input
      dataTestId={dataTestId}
      defaultValue={defaultValue}
      control={control}
      className="input--large input--with-info"
      type="number"
      mask="99999999999"
      name="ean"
      register={register}
      validations={{
        required: t('meter.ean.not.eligible.error'),
        pattern: {
          value: /^[0-9]+$/,
          message: t('meter.ean.not.eligible.error'),
        },

        validate: {
          validEan: (value: string) => {
            return EanUtils.isValidGTIN(`${PREFIX}${value}`)
              ? true
              : t('meter.ean.not.eligible.error');
          },
        },
      }}
      error={error}
      prefix={<span className="input__prefix">{PREFIX}</span>}
      suffix={<InformationIcon onClick={onClickInfo} />}
      beforeMaskedValueChange={handleBeforeMaskedValueChange}
    />
  );
}
